import { Observable } from 'rxjs';
import { DevicesProvider } from './../../providers/devices/devices';
import { TasksProvider } from './../../providers/tasks/tasks';
import { Component,  ViewEncapsulation } from '@angular/core';
import { NavController, NavParams, Platform, AlertController } from 'ionic-angular';
import { TaskQL, Task, TaskData } from '../../providers/tasks/models';
import { getValue } from '../../providers/tasks/filters';
import { ENV } from '../../environments/environment';

@Component({
  selector: 'page-task-code',
  templateUrl: 'task-code.html',
  encapsulation: ViewEncapsulation.None,
})
export class TaskCodePage {
  public task: TaskQL;
  public code: string = '';
  public taskData: TaskData;
  private extras: any;
  private isrepair: boolean = false;
  private isreplace: boolean = false;
  private serial: string;
  public showTypeBox: boolean = false;
  showBrowserScanner: boolean = true;
  public torch: boolean = false;
  scanCodeVerified: boolean = false;
  enableFlaslight: boolean = false;
  devicePass: string;

  cameraPermission: boolean = true;

  cameras: any;
  selectedCamera: any = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private tasksProvider: TasksProvider,
    private devicesProvider: DevicesProvider,
    public platform: Platform,
    public alertCtrl: AlertController
  ) {
    this.task = this.navParams.get('task');
    this.extras = this.navParams.get('extras');
    this.isrepair = this.extras && this.extras.isrepair ? this.extras.isrepair : null;
    this.isreplace = this.extras && this.extras.isreplace ? this.extras.isreplace : null;
  }

  ionViewDidLoad() {}
  ionViewDidEnter() {
    this.taskData = this.tasksProvider.getTaskData(this.task.id);
    this.scanCode();
  }

  isCordova() {
    return this.platform.is('cordova');
  }
  async photoLight(){
    this.torch = !this.torch;
  }

  scanCode() {
    this.showTypeBox = false;
    const isCordova = this.isCordova();
    if (isCordova) {
      // Cordova
    } else {
      this.browserScanner();
    }
  }

  noCordovaUpdate() {
    this.checkAndVerifyCode().subscribe(result => {
      if (result) {
        this.updateTask();
      }
    });
  }

  checkAndVerifyCode() {
    return Observable.create(observer => {
      let flag = false;
      this.devicesProvider.qrCodeParseValidated(this.code, this.task.deviceType).subscribe(
        serial => {
          this.serial = serial;
          if (this.isrepair || this.task.type === "deinstallation" || (this.task.type === 'repair' && this.isreplace === null)) {
            if (this.task.install && this.serial === this.task.install.serial) {
              flag = true;
            } else {
              flag = false;
              let message = 'Device serial does not match. Make sure this is the correct device.';
              let alert = this.alertCtrl.create({
                title: 'Error!',
                message: message,
                buttons: ['OK']
              });
              alert.present();
            }
          } else {
            flag = true;
          }
          observer.next(flag);
        },
        e => {
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message: e,
            buttons: ['OK']
          });
          alert.present();
          //observer.error(e);
        }
      );
    });
  }

  isFirstTime() {
    return this.isreplace || (this.code && this.code.length > 0) ? false : true;
  }

  validateCode(serial) {
    return Observable.create(observer => {
      let flag = false;
      if (
        this.task.deviceType === Task.DeviceTypeEnum.FireAlarm &&
        serial.toLowerCase().indexOf('fireal') > 0
      ) {
        // check serial
        console.log('is fire alarm');
        flag = true;
      } else if (
        this.task.deviceType === Task.DeviceTypeEnum.Security &&
        serial.toLowerCase().indexOf('secdev') > 0
      ) {
        // check serial
        console.log('is security');
        flag = true;
      } else if (
        this.task.deviceType === Task.DeviceTypeEnum.Geyser &&
        serial.toLowerCase().indexOf('geyser') > 0
      ) {
        console.log('is geyser');
        // check serial
        flag = true;
      }
      console.log(serial, serial.toLowerCase().indexOf('geyser') > 0);

      if (flag) {
        observer.next('success');
      } else {
        observer.error('error');
      }
    });
  }

  updateTask() {
    let type = !this.isrepair ? 'code' : 'verified';
    this.validateCode(this.serial).subscribe(
      () => {
        if (this.isreplace) {
          this.tasksProvider.updateTaskData(this.task, 'newSerial', this.serial).subscribe(data => {
            // check
            console.log('set active', data);
          });
        }

        let partial;
        const serial = this.serial;
        if (this.isreplace) {
          partial = {
            status: 'inprogress',
            install: {
              newSerial: serial,
              activationPassword: this.devicePass
            }
          };
        } else {
          partial  = {
            status: 'inprogress',
            install: {
              serial: serial,
              activationPassword: this.devicePass
            }
          };
        }
        this.tasksProvider.updateTaskPartial(this.task.id, partial).subscribe(
          updateResult => {
            this.tasksProvider.updateTaskData(this.task, type, this.serial).subscribe(data => {
              this.tasksProvider.updateTaskData(this.task, 'test', null).subscribe(data => {
                this.tasksProvider.setSelectedTask(updateResult);
                this.navCtrl.pop();
              });
            });
          },
          err => {
            let message =
              err.error && err.error.message
                ? err.error.message
                : 'Failed to update task, please check your internet connection and try again.';
            let alert = this.alertCtrl.create({
              title: 'Error',
              message: message,
              buttons: ['OK']
            });
            alert.present();
          }
        );
      },
      error => {
        let message =
          'The serial does not match the device for this task. Please check if this is the correct serial of the device to be installed.';
        let alert = this.alertCtrl.create({
          title: 'Error',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      }
    );
  }

  parseInputCode(code){
    let input = code.replace('GEYSER','').replace('SECDEV','');
    input = input.replace('sngeyser:','')
    input = input.replace('snsecdev:','')
    input = input.trim()

    if(input.length === 8 && !this.task.deviceType.includes('fire')){
      input = this.task.deviceType.includes('geyser') ? 'sngeyser:' + input + 'GEYSER' : 'snsecdev:' + input + 'SECDEV'
    }
    return input;
  }

  confirmCode(evt){
    this.enableFlaslight = false;
    this.showBrowserScanner = false;
    this.torch = false;
    let value = this.parseInputCode(evt);
    this.scanCodeVerified = false;
    this.code = value;
    if(this.code.includes("=")){
      this.devicePass = value.substring(value.indexOf("=")+1);
      localStorage.setItem("lastPass", this.devicePass);
    }
    this.checkAndVerifyCode().subscribe(result => {
      if (result) {
        this.showBrowserScanner = false;
        this.scanCodeVerified = true;
      }
    });
  }

  onHasPermission(evt){
    this.cameraPermission = evt;
  }
  onCamerasFound(evt){
    this.cameras = evt.filter(cam => {
      return !cam.label.includes("IR");
    });

    if(this.cameras.length > 0){
      this.selectedCamera = this.cameras[0];
    }
    this.enableFlaslight = true;
  }

  getCamera(evt){

    return this.selectedCamera;
  }
  onTorchCompatible(evt){
    // alert("TOurch: "+JSON.stringify(evt))
  }
  camerasNotFoundHandler(evt){
    // alert("NOCAM: "+JSON.stringify(evt))
  }
  showQrTypeBox(){
    this.enableFlaslight = false;
    this.showBrowserScanner = false;
    this.scanCodeVerified = false;
    this.torch = false;
    this.showTypeBox = true;
    this.selectedCamera = null;

    const serial = getValue(this.task,'install.serial');
    if(ENV.base.includes("qa") && serial){
      // this.code = serial;
    }

    setTimeout(() => {
      let input = document.getElementById('type-code');
      input.focus();
    }, 100)

  }
  browserScanner(){
    this.showBrowserScanner = true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-code/task-code.ts